import { gql } from "@apollo/client";
import { TypeDefinitionAttributeFields } from "../fragments/typeDefinitionAttribute";

// Create form metadata. roleIds arrives as a required multiselect with a
// dataLoaderConfig on contactRoleList — TDAForm renders and validates it
// (required on a list maps to min 1) without extra wiring.
export const ContactPersonCreateTdas = gql`
    query ContactPersonCreateTdas($clientId: ID!) {
        contactPersonList(filter: {clientId: {equals: $clientId}}) {
            typeDefinitionAttributeList(typeDefinitionIndex: CONTACT_PERSON_CREATE) {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
